import LetterTable from './letter-table';

export default LetterTable;
